import { SignUp } from '@clerk/clerk-react';

const IS_SATELLITE = import.meta.env.VITE_CLERK_IS_SATELLITE === 'true';
const CLERK_DOMAIN = import.meta.env.VITE_CLERK_DOMAIN;

export default function SignUpPage() {
  if (IS_SATELLITE) {
    // Forward Clerk ticket params through to the hosted sign-up page so the
    // organization-invitation accept flow survives the bounce. Without this,
    // a new invitee landing here from /v1/tickets/accept loses their ticket
    // and gets a generic sign-up form instead of the pre-filled, email-
    // verified one Clerk would otherwise drive.
    const params = new URLSearchParams(window.location.search);
    const ticket = params.get('__clerk_ticket');
    const status = params.get('__clerk_status');
    let url = `https://accounts.${CLERK_DOMAIN}/sign-up?redirect_url=${encodeURIComponent(window.location.origin)}`;
    if (ticket) url += `&__clerk_ticket=${encodeURIComponent(ticket)}`;
    if (status) url += `&__clerk_status=${encodeURIComponent(status)}`;
    window.location.href = url;
    return null;
  }

  return (
    <div className="login-page d-flex align-items-center justify-content-center">
      <SignUp
        routing="path"
        path="/sign-up"
        signInUrl="/sign-in"
        forceRedirectUrl="/dashboard"
        localization={{
          signUp: {
            emailCode: {
              subtitle: "Enter the verification code sent to your email. Check your junk folder if you don't see it within 2 minutes.",
            },
          },
        }}
      />
    </div>
  );
}
